import React from 'react';
import { Container, Row, Col, Image, ListGroup, Badge } from 'react-bootstrap';
import config from '../config';

/**
 * @description Раздел с основной информацией о компании
 * @returns {Element}
 * @constructor
 */
function Home() {
    return (
        <Container fluid className="py-5 bg-light">
            <Row className="align-items-center mb-4">
                <Col xs={12} md={4} className="text-center text-md-start mb-3 mb-md-0">
                    <Image
                        src={"logo.png"}
                        roundedCircle
                        fluid
                        alt={`${config.companyName} логотип`}
                        className="shadow-sm"
                        style={{
                            width: '100%',
                            maxWidth: '200px',
                            height: 'auto',
                            minWidth: '80px'
                        }}
                    />
                </Col>
                <Col xs={12} md={8}>
                    <h1 className="display-4 fw-bold text-success">
                        {config.companyName}
                    </h1>
                </Col>
            </Row>

            <Row className="mb-5">
                <Col>
                    <div className="bg-white p-4 rounded shadow-sm border">
                        <h2 className="h4 text-success mb-3">О компании</h2>
                        <p className="fs-5">{config.companyDescription}</p>
                    </div>
                </Col>
            </Row>

            <Row className="mb-5">
                <Col>
                    <h2 className="h3 text-center mb-4 text-success">Наши ключевые услуги</h2>
                    <ListGroup variant="flush" className="shadow-sm rounded">
                        {config.keyServices.map((service, index) => (
                            <ListGroup.Item
                                key={index}
                                className="p-4 border-bottom"
                            >
                                <div className="d-flex align-items-start">
                                    <Badge
                                        bg="success"
                                        className="me-3 fs-6"
                                        style={{ minWidth: '36px' }}
                                    >
                                        {index + 1}
                                    </Badge>
                                    <div>
                                        <h5 className="mb-1">{service.name}</h5>
                                    </div>
                                </div>
                            </ListGroup.Item>
                        ))}
                    </ListGroup>
                </Col>
            </Row>
        </Container>
    );
}

export default Home;
